<router-outlet></router-outlet>
<div class="flex flex-col items-center justify-center absolute bottom-0.5 left-1 z-999">
    <span class="text-xs text-hint p-3">v{{environment.version}} by Vuframe®</span>
</div>
